import React, { useEffect } from "react";
import { withRedux, getTextColor } from "helpers";
import styled from "react-emotion";
import Punchcard from "./Punchcard";
import { getUserPunchCards } from "apis";

const PageContainer = styled("div")`
  padding: 0.1em;
  box-shadow: none;
  background-color: white;

  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media only screen and (min-width: 500px) {
    padding: 1em;
    background-color: ${(props) =>
      props.backgroundColor ? props.backgroundColor : "white"};
    box-shadow: 3px 3px 13px rgba(120, 120, 120, 0.5);
  }
`;

const PromptContainer = styled("div")`
  color: black;
  @media only screen and (min-width: 500px) {
    color: ${(props) => (props.color ? props.color : "black")};
  }
`;

const ATag = styled("a")`
  color: black;
  @media only screen and (min-width: 500px) {
    color: ${(props) => (props.color ? props.color : "black")};
  }
`;

function PunchcardsWebComponent(props) {
  const {
    activeTemplate: { backgroundColor },
    cards,
    actions: { getPunchCards, removePunchCards, setPunchCards },
    platformInfo: {
      status: { user },
    },
    activeApp: { id, deeplinkUrl },
  } = props;

  const isAnonUser = user ? user.tempUser : true;

  const getUserPunchCardsHelper = async () => {
    const appId = props.activeApp.id;
    const userId = props.platformInfo.status.user.id;
    try {
      await getUserPunchCards(userId, appId).then((userPunchCards) => {
        // console.log("GOT BACK userPunchCards FROM API");
        // console.dir(userPunchCards);
        // setStore(store);
        setPunchCards(userPunchCards);
        return userPunchCards;
      });
    } catch (e) {
      console.error(e);
    }
  };

  const getDefaultPunchcards = async () => {
    const appId = props.activeApp.id;
    try {
      await getPunchCards(appId).then((punchCards) => {
        // console.log("GOT BACK defaultPunchCards FROM API");
        // console.dir(punchCards);
        // setStore(store);
        setPunchCards(punchCards);
        return punchCards;
      });
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (cards) {
      removePunchCards(id);
    }
    if (!isAnonUser) {
      // console.log("\n\n\nGot user id: setting custom punchcards");
      // console.log(user.id);
      getUserPunchCardsHelper();
    } else if (user) {
      // console.log("\n\n\nNo user detected: setting default punchcards");
      getDefaultPunchcards();
    }
  }, [user]);

  // useEffect(() => {}, [user]);

  if (!cards) return null;

  const sortedIds = [];
  Object.keys(cards).forEach((id) => {
    const card = cards[id];
    if (card.retired) {
      sortedIds.push(id);
    } else {
      sortedIds.unshift(id);
    }
  });

  const textColour = getTextColor(backgroundColor);
  return (
    <PageContainer backgroundColor={backgroundColor}>
      <PromptContainer style={{ margin: "20px" }} color={textColour}>
        Our punch card loyalty program is exclusively available on our mobile
        app. Click{" "}
        <ATag href={deeplinkUrl} target="_blank" color={textColour}>
          here
        </ATag>{" "}
        to download!
      </PromptContainer>
      {cards &&
        sortedIds.map((id) => {
          const card = cards[id];
          // console.log("Got punchcard with name: |" + card.title + "|");
          // console.dir(card);
          if (card.retired != 1)
            return (
              <Punchcard
                {...card}
                background={backgroundColor}
                barColor={props.activeApp.view.navigation.navBarColor}
                key={id}
                isAnonUser={isAnonUser}
              />
            );
        })}
    </PageContainer>
  );
}

export default withRedux(PunchcardsWebComponent);
